import { render, staticRenderFns } from "./TemplatePost.vue?vue&type=template&id=1fe17536&scoped=true&"
import script from "./TemplatePost.vue?vue&type=script&lang=js&"
export * from "./TemplatePost.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePost.vue?vue&type=style&index=0&id=1fe17536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe17536",
  null
  
)

export default component.exports